import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { PopoverModule, TooltipModule } from 'ngx-bootstrap';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { FormalizeCommentModule } from 'src/app/shared/ai-assistant/formalize-comment/formalize-comment.module';
import { VoiceInputModule } from 'src/app/shared/ai-assistant/voice-input/voice-input.module';
import { RequisitionCardIconsModule } from 'src/app/shared/requisition-card-icons/requisition-card-icons.module';
import { RequisitionSkillsModule } from 'src/app/shared/requisition-skills/requisition-skills.module';
import { EditSharedReqPageComponent } from './edit-shared-req-page.component';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.editSharedReq',
    url: '/editSharedReq',
    component: EditSharedReqPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      jobId: null,
      corporateCompanyId: null,
      buId: null,
      jobState: null,
      jobName: null,
      jobType: null,
      requisitionInfo: null
    }
  }
];

@NgModule({
  declarations: [EditSharedReqPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    PipesModule,
    RequisitionCardIconsModule,
    RequisitionSkillsModule,
    VoiceInputModule,
    FormalizeCommentModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [EditSharedReqPageComponent],
  entryComponents: [EditSharedReqPageComponent]
})
export class EditSharedReqPageModule { }
